<template>
  <div class="no-result flex flex-col justify-center items-center text-gray-80 h-504px">
    <nd-img src="@/assets/images/product/no-result.svg" alt="no-result" class="w-120px h-90px" />
    <p class="text-center text-base flex flex-col items-center mt-5 gap-1">
      <slot />
    </p>
  </div>
</template>
